const extractFileData = require("./extractFileData");
const findFeaturedImage = require("./findFeaturedImage");

module.exports = function extractMediaData(
	entity,
	media_field_name,
	sitemap,
	file_field_name = "field_media_image"
) {
	if (entity) {
		let media_rel;
		if (media_field_name) {
			media_rel =
				entity && entity.relationships && entity.relationships[media_field_name]
					? entity.relationships[media_field_name].data
					: null;
		} else {
			media_rel =
				entity && entity.relationships ? findFeaturedImage(entity.relationships) : null;
		}
		const file_data = media_rel
			? extractFileData(media_rel, file_field_name, sitemap)
			: null;

		return file_data;
	} else {
		return null;
	}
};
